import { StrictMode, Component, type ErrorInfo, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@/app/AppContext';
import { App } from '@/app/App';
import { ToastProvider } from '@/components/Toast';
import './index.css';

class StorageBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(_error: Error, _info: ErrorInfo) { /* Never log household records. */ }
  render() {
    if (this.state.failed) return <main className="mx-auto max-w-md p-6 space-y-4"><h1 className="text-2xl">Kai could not open</h1><p role="alert">Device storage may be unavailable. Allow storage for this site, then try again. Your saved data has not been cleared.</p><button className="btn-primary" onClick={() => location.reload()}>Try again</button></main>;
    return this.props.children;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><StorageBoundary><BrowserRouter><ToastProvider><AppProvider><App /></AppProvider></ToastProvider></BrowserRouter></StorageBoundary></StrictMode>,
);
